module.exports = __webpack_public_path__ + "img/img007.4a1bfa8f.png";